namespace SPA
{
	export namespace Navigation
	{

		export class BreadCrumb
			extends ui.base.HTMLPresentation<HTMLOListElement>
		{

			private list: JQuery[];

			public constructor( child: string )
			{
				super( 'ol' );

				this.list = new Array;

				this.addClass( 'breadcrumb' );

				this.list.push( ui.$$.li().text( child ).addClass('text-muted') );

				this.findParent( child );
			}

			public build(): void
			{
				this.list.reverse().forEach( (element) => this.append( element ) );
			}

			private findParent( child: string )
			{
				new Wollmilch.AJAX(
					{
						url: 'customer/showHierarchie/' + encodeURIComponent( btoa( child ) ),

						on:
						{
							success: ( text: string ): void =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj || !obj.success || !obj.data )
								{
									return;
								}

								if ( obj && obj.data && obj.data.parent )
								{
									obj.data.parent.forEach( (element: any) => {

										this.list.push(
											ui.$$.li()
											.text( element )
											.attr( 'style', 'cursor:pointer')
											.on( 'click', () => this.openBreadCrumbLink() )
										);

									});

									this.build();
								}
							}
						}
					}
				).send();
			}

			private openBreadCrumbLink()
			{
				// TODO hier den Web zum Entry finden
				alert('ge-clicked');
			}

		}

	}

}
